module.exports = __webpack_public_path__ + "img/commerc-e-logo.a3c8e096.png";